import { DayPilot } from '@daypilot/daypilot-lite-react';

try {
  DayPilot.Locale.register(
    new DayPilot.Locale('fr-fr', {
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
      timePattern: 'HH:mm',
      datePattern: 'dd/MM/yyyy',
      dateTimePattern: 'dd/MM/yyyy HH:mm',
      timeFormat: 'Clock24Hours',
      weekStarts: 1,
    })
  );
} catch { /* locale already registered */ }

export const FR_MONTHS = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
];

export const FR_DAYS_SHORT = ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'];

export const VIEWS = {
  week: { scale: 'Day', cellDuration: 1440, days: 7, timeHeaders: [{ groupBy: 'Month' }, { groupBy: 'Day', format: 'ddd d' }], cellWidth: 80 },
  month: { scale: 'Day', cellDuration: 1440, days: 31, timeHeaders: [{ groupBy: 'Month' }, { groupBy: 'Day', format: 'd' }], cellWidth: 45 },
  year: { scale: 'Day', cellDuration: 1440, days: 365, timeHeaders: [{ groupBy: 'Month', height: 25 }, { groupBy: 'Week' }, { groupBy: 'Day', format: 'd' }], cellWidth: 25 },
};

// Palette DS « Cosmos » (hex appliqués en style aux événements du scheduler).
export const COLOR_OPTIONS = [
  { name: 'Iris', id: '#5a4fe0' },
  { name: 'Cyan', id: '#22d3ee' },
  { name: 'Émeraude', id: '#10b981' },
  { name: 'Ambre', id: '#f59e0b' },
  { name: 'Violet', id: '#8b5cf6' },
  { name: 'Rose', id: '#f43f5e' },
];

export const SPECIAL_ROWS = ['_histogram', '_utilization'];

export const DOTS_SVG = '<svg viewBox="0 0 16 16" fill="#555" width="14" height="14"><circle cx="3" cy="8" r="1.5"/><circle cx="8" cy="8" r="1.5"/><circle cx="13" cy="8" r="1.5"/></svg>';

